// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* styles.module.css*/
.Unauthorized_container__pC4oU {
  display: flex;
  align-items: center;
  justify-content: center;
}

.Unauthorized_card__\\+893m {
  background-color: #ffffff;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-width: 400px;
  width: 100%;
}

.Unauthorized_title__oecEk {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #333333;
}

.Unauthorized_message__Z1mFd {
  font-size: 1rem;
  margin-bottom: 1.5rem;
  color: #555555;
}

.Unauthorized_button__WzbeS {
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  background-color: #007bff;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.Unauthorized_button__WzbeS:hover {
  background-color: #0056b3;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Base/Unauthorized/Unauthorized.module.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* styles.module.css*/\r\n.container {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.card {\r\n  background-color: #ffffff;\r\n  padding: 2rem;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n  text-align: center;\r\n  max-width: 400px;\r\n  width: 100%;\r\n}\r\n\r\n.title {\r\n  font-size: 1.5rem;\r\n  margin-bottom: 1rem;\r\n  color: #333333;\r\n}\r\n\r\n.message {\r\n  font-size: 1rem;\r\n  margin-bottom: 1.5rem;\r\n  color: #555555;\r\n}\r\n\r\n.button {\r\n  padding: 0.75rem 1.5rem;\r\n  font-size: 1rem;\r\n  background-color: #007bff;\r\n  color: #ffffff;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.button:hover {\r\n  background-color: #0056b3;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Unauthorized_container__pC4oU`,
	"card": `Unauthorized_card__+893m`,
	"title": `Unauthorized_title__oecEk`,
	"message": `Unauthorized_message__Z1mFd`,
	"button": `Unauthorized_button__WzbeS`
};
export default ___CSS_LOADER_EXPORT___;
